import React, { useEffect, useState } from "react"
import API from "../../../Common/API"
import PreviewProfileLoader from "../../../Components/Loaders/PreviewProfileLoader"
import PreviewRegistration from "../../Auth/PreviewRegistration"
import PreviewUser from "./PreviewUser"

const ViewUser = ({ match }) => {


    const [loading, setLoading] = useState(true)
    const [userDetails, setUserDetails] = useState({})

    useEffect(() => {
        setLoading(true)
        API.get(`/user/getFullUserDetailsById/${match.params.id}`).then((res) => {
            if (res.status === 200) {
                setUserDetails(res.data.data)
                setLoading(false)
            }
        })
    }, [match.params.id])
    
    return (
        <>
            {
                loading ? <PreviewProfileLoader /> : <PreviewUser userValues={userDetails} />
            }
        </>
    )
}

export default ViewUser